import type { TraceProgress, TraceStage } from './trace-progress';

/** No time-based percentage: some images need substantially more fitting work than others. */
export function TraceProcessingIndicator({ progress, locale }: { progress: TraceProgress; locale: string }) {
  const english = locale === 'en';
  const labels: Record<TraceStage, readonly [string, string]> = {
    decoding: ['Đọc ảnh gốc', 'Reading the original image'],
    coverage: ['Phân tích sắc độ và chi tiết', 'Analyzing coverage and details'],
    contours: ['Đọc đường bao', 'Reading contours'],
    fitting: ['Khớp đường cong', 'Fitting curves'],
    validating: ['Kiểm tra độ bám đường bao', 'Checking contour fidelity'],
    refining: ['Tối ưu điểm neo theo ảnh gốc', 'Optimizing anchors against the original'],
    tracing: ['Dựng các đường path', 'Tracing paths'],
  };
  const title = english ? 'Reading and tracing paths…' : 'Đang đọc và vẽ path…';
  const detail = labels[progress.stage][english ? 1 : 0];
  const count = progress.completed !== undefined && progress.total !== undefined
    ? `${progress.completed.toLocaleString(locale)} / ${progress.total.toLocaleString(locale)}` : '';
  return <div className="vectorize-processing" data-testid="vectorize-processing">
    <span className="vectorize-processing-ring" role="progressbar" aria-label={title} aria-valuetext={detail}/>
    <div className="vectorize-processing-copy"><strong>{title}</strong><span role="status" aria-live="polite" aria-atomic="true">{detail}</span>{count && <small aria-live="off">{count}</small>}</div>
  </div>;
}
